import { render, staticRenderFns } from "./specialList.vue?vue&type=template&id=53f5ae00&scoped=true"
import script from "./specialList.vue?vue&type=script&lang=js"
export * from "./specialList.vue?vue&type=script&lang=js"
import style0 from "./specialList.vue?vue&type=style&index=0&id=53f5ae00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5ae00",
  null
  
)

export default component.exports